var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _g5, _g6, _g7, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeslaPlug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.7538 47.0205C90.7538 67.2346 75.9309 84.9637 55.6679 84.9637C35.4049 84.9637 19.7495 68.5543 19.7495 48.3403C19.7495 28.1262 25.9898 20.9805 55.6679 20.9805C85.346 20.9805 90.7538 26.8065 90.7538 47.0205Z",
    fill: "#222E36"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.7538 46.6987C92.0961 44.2331 92.8575 41.407 92.8575 38.4006C92.8575 28.7828 85.0427 20.9805 75.3953 20.9805C73.5884 20.9805 71.8396 21.2573 70.2005 21.7659C66.1349 21.2251 61.3402 20.9805 55.6679 20.9805C49.5051 20.9805 44.3619 21.2959 40.0641 21.9654C38.2637 21.341 36.3406 20.9805 34.3208 20.9805C24.6798 20.9805 16.8585 28.7764 16.8585 38.4006C16.8585 41.9413 17.9233 45.2373 19.7495 47.9862C19.7495 48.1021 19.7495 48.2179 19.7495 48.3403C19.7495 56.7606 22.4728 64.5115 27.1062 70.7045C27.0545 70.9941 27.0223 71.2838 27.0223 71.5735C27.0223 79.4274 39.2962 85.7877 54.4353 85.7877C69.5745 85.7877 80.945 79.878 81.7968 72.4233C87.4369 65.5866 90.7538 56.5868 90.7538 47.027C90.7538 46.9175 90.7538 46.8145 90.7538 46.6987ZM81.0547 68.7989C78.112 63.3656 67.3159 57.3529 54.4353 57.3529C46.969 57.3529 32.9785 61.7562 28.4678 67.7496C25.338 63.063 23.3504 57.5203 22.8729 51.5269C25.9381 54.192 29.9391 55.8143 34.3208 55.8143C43.9618 55.8143 51.7831 48.0184 51.7831 38.3942C51.7831 32.5231 48.8598 27.3408 44.4007 24.1864C47.6595 23.8452 51.383 23.6843 55.6292 23.6843C59.3139 23.6843 62.5857 23.8001 65.509 24.0383C60.9337 27.1799 57.9265 32.433 57.9265 38.3942C57.9265 48.0119 65.7413 55.8143 75.3888 55.8143C80.1448 55.8143 84.4426 53.9152 87.5918 50.838C87.0045 57.4623 84.6814 63.6682 81.0482 68.7925L81.0547 68.7989Z",
    fill: "#0D1214"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9144 42.0686C93.6676 23.3178 80.7213 18 61.095 18C54.1825 18 45.319 18 36.7915 18.8315C26.7135 19.8242 16.6678 24.4522 15.2013 40.2251C15.2013 40.2251 12.6366 61.5091 25.8155 77.1788C25.8801 77.2561 25.9512 77.3399 26.0158 77.4173C26.3259 77.7782 26.636 78.1392 26.9654 78.4937C27.1399 78.6871 27.3208 78.874 27.5016 79.061C27.7471 79.3188 27.9926 79.5766 28.251 79.8344C28.7162 80.2985 29.1942 80.7562 29.6917 81.201C35.5705 86.4736 47.4574 90.5087 56.211 89.9479C68.0785 89.1873 74.3644 85.6743 79.8168 81.0527C80.2949 80.6466 80.7665 80.2083 81.2252 79.7507C89.7204 71.4614 95.7995 55.45 94.9144 42.075V42.0686ZM82.3686 70.6492C81.7484 71.4872 80.4887 71.4743 79.9331 70.5976C74.7778 62.463 63.621 59.8396 53.8143 59.6591C48.9109 59.5689 36.7463 62.5791 29.401 69.5405C28.671 70.2302 27.5016 70.0368 26.9331 69.2053C23.3025 63.8424 21.0866 57.4095 20.7894 50.4481C21.022 49.4877 21.5453 49.3588 22.1526 49.8357C25.5119 52.8782 30.1568 54.5283 35.1894 53.845C42.1987 52.8911 47.8838 47.2252 48.8463 40.238C49.7249 33.8631 46.8372 28.0877 42.0889 24.8003C41.2878 24.246 41.6173 22.9761 42.5864 22.8601C46.3204 22.4025 50.6617 22.1898 55.7007 22.1898C60.0937 22.1898 63.9569 22.338 67.3485 22.6603C68.324 22.757 68.6083 24.0204 67.7878 24.5554C62.8651 27.7654 59.8223 33.5924 60.6428 40.0639C61.5472 47.1672 67.3162 52.9362 74.4354 53.8579C80.2949 54.6121 85.6375 52.2142 89.0033 48.1276C89.3069 47.8376 89.7462 47.9213 89.8431 48.4435C89.6558 56.6812 86.936 64.4483 82.3751 70.6492H82.3686Z",
    fill: "#4F6B77"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3397 47.497C37.7997 47.497 42.2259 43.0815 42.2259 37.6346C42.2259 32.1878 37.7997 27.7722 32.3397 27.7722C26.8796 27.7722 22.4534 32.1878 22.4534 37.6346C22.4534 43.0815 26.8796 47.497 32.3397 47.497Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8311 37.6346C36.8311 40.1067 34.8177 42.1152 32.3397 42.1152C29.8617 42.1152 27.8483 40.1067 27.8483 37.6346C27.8483 35.1626 29.8617 33.1541 32.3397 33.1541C34.8177 33.1541 36.8311 35.1626 36.8311 37.6346Z",
    fill: "url(#paint0_linear_668_20494)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.46 47.497C81.9201 47.497 86.3463 43.0815 86.3463 37.6346C86.3463 32.1878 81.9201 27.7722 76.46 27.7722C71 27.7722 66.5738 32.1878 66.5738 37.6346C66.5738 43.0815 71 47.497 76.46 47.497Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9686 37.6604C71.9686 40.1324 73.982 42.1409 76.46 42.1409C78.938 42.1409 80.9514 40.1324 80.9514 37.6604C80.9514 35.1883 78.938 33.1798 76.46 33.1798C73.982 33.1798 71.9686 35.1883 71.9686 37.6604Z",
    fill: "url(#paint1_linear_668_20494)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7092 72.0757C39.7092 73.8139 38.296 75.2237 36.5536 75.2237C34.8112 75.2237 33.398 73.8139 33.398 72.0757C33.398 70.3376 34.8112 68.9277 36.5536 68.9277C38.296 68.9277 39.7092 70.3376 39.7092 72.0757Z",
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9629 72.0757C74.9629 73.8847 73.4916 75.3524 71.6782 75.3524C69.8649 75.3524 68.3936 73.8847 68.3936 72.0757C68.3936 70.2667 69.8649 68.799 71.6782 68.799C73.4916 68.799 74.9629 70.2667 74.9629 72.0757Z",
    fill: "black"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.546 70.7045C58.546 73.1894 56.5262 75.1979 54.0352 75.1979C51.5443 75.1979 49.5309 73.1829 49.5309 70.7045C49.5309 68.226 51.5508 66.2046 54.0352 66.2046C56.5197 66.2046 58.546 68.2196 58.546 70.7045Z",
    fill: "black"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3852 83.1999H49.0728C48.2919 83.1999 47.6595 82.569 47.6595 81.7901C47.6595 81.0111 48.2919 80.3802 49.0728 80.3802H60.3852C61.166 80.3802 61.7984 81.0111 61.7984 81.7901C61.7984 82.569 61.166 83.1999 60.3852 83.1999Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3529 82.9553H49.0728C48.4274 82.9553 47.9047 82.4338 47.9047 81.7901C47.9047 81.1463 48.4274 80.6249 49.0728 80.6249H60.3529C60.9982 80.6249 61.5209 81.1463 61.5209 81.7901C61.5209 82.4338 60.9982 82.9553 60.3529 82.9553Z",
    fill: "#1E272D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3649 70.7045C56.3649 71.9856 55.3259 73.022 54.0417 73.022C52.7575 73.022 51.7186 71.9856 51.7186 70.7045C51.7186 69.4234 52.7575 68.387 54.0417 68.387C55.3259 68.387 56.3649 69.4234 56.3649 70.7045Z",
    fill: "url(#paint2_linear_668_20494)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7624 72.0758C72.7624 72.6745 72.2784 73.1573 71.6782 73.1573C71.0781 73.1573 70.5941 72.6745 70.5941 72.0758C70.5941 71.4771 71.0781 70.9943 71.6782 70.9943C72.2784 70.9943 72.7624 71.4771 72.7624 72.0758Z",
    fill: "url(#paint3_linear_668_20494)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6377 72.0758C37.6377 72.6745 37.1537 73.1573 36.5536 73.1573C35.9535 73.1573 35.4695 72.6745 35.4695 72.0758C35.4695 71.4771 35.9535 70.9943 36.5536 70.9943C37.1537 70.9943 37.6377 71.4771 37.6377 72.0758Z",
    fill: "url(#paint4_linear_668_20494)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_20494",
    x1: 32.3397,
    y1: 42.1087,
    x2: 32.3397,
    y2: 33.1541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_668_20494",
    x1: 76.46,
    y1: 42.1409,
    x2: 76.46,
    y2: 33.1798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_668_20494",
    x1: 54.0417,
    y1: 73.022,
    x2: 54.0417,
    y2: 68.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_668_20494",
    x1: 71.6782,
    y1: 73.1573,
    x2: 71.6782,
    y2: 71.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_668_20494",
    x1: 36.5536,
    y1: 73.1573,
    x2: 36.5536,
    y2: 71.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeslaPlug);
export default __webpack_public_path__ + "static/media/tesla_plug.06c0909d8711b24ea33ddd22e24a2009.svg";
export { ForwardRef as ReactComponent };